import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import "react-datetime/css/react-datetime.css";
import { Typeahead } from 'react-bootstrap-typeahead';
import {Form} from 'react-bootstrap';
import { format } from 'date-fns';
import {getUserTimeZone} from '../../../utils/userGroupUrlCheck';
import CustomMultiSelect from '../../../components/commons/helpers/customMultiSelect';
import { LBL_DATE_FROM,LBL_DATE_TO,LBL_SHIFTS,LBL_UNALLOCATED_SHIFT,LBL_DEPARTMENTS,LBL_CLIENT, LBL_EVENT, LBL_SHIFT, LBL_LOCATION, LBL_TITLE } from '../../../configs/labelConfigs';
import { EVENT_STATUS, SHIFT_STATUS, SHIFT_STATUS_ESTIMATION, SHIFT_STATUS_REESTIMATION } from '../../../configs/staticConfigs';

import {filterClientsListAction,shiftsFilterEventsListAction,shiftsFilterShiftsListAction,shiftsFilterLocationsListAction} from '../../../actions/eventActions'; 
import * as types from '../../../actions';
import { fromDashboard, serverTimeAction, shiftTitle } from '../../../actions/commonActions';
import {converDateToLocal} from '../../../utils/commonUtilities';
import {titleCase} from '../../../utils/changeCase';


let eventStatusData = [];
EVENT_STATUS.forEach(item => {
    eventStatusData.push({value:item.statusCode,label:item.statusString}); 
});

// NEED ESTIMATION AND RESTIMATION ONE BY ONE SO USING TWO LOOPS 
let arrFirst = [];
let arrNext  = [];
let shiftStatusData = [];
SHIFT_STATUS.forEach(item => {
    if(parseInt(item.statusCode,10)===parseInt(SHIFT_STATUS_ESTIMATION,10) || parseInt(item.statusCode,10)===parseInt(SHIFT_STATUS_REESTIMATION,10)) {
        arrFirst.push({value:item.statusCode,label:item.statusString}); 
    }
    else {
        arrNext.push({value:item.statusCode,label:item.statusString}); 
    }
});  

shiftStatusData = [...arrFirst, ...arrNext]; 

class FilterShift extends Component {

    constructor(props){
        super(props)
        let currentDate = new Date();
        let timeZone =  getUserTimeZone(window.location);
        let strDatetime = format(currentDate, 'yyyy-MM-dd HH:mm:ss');
        //let convertedDate = converDateToLocal(strDatetime,timeZone.utc_offset,'dateObj','-');
        let convertedDate = converDateToLocal(currentDate,timeZone.utc_offset,'dateObj','-');
        let startfrom= new Date(format(convertedDate,'yyyy-MM-dd'));
        let endTo = convertedDate.setDate(convertedDate.getDate() + 1); 
        endTo = new Date(format(endTo,'yyyy-MM-dd'));
        let defaultEndDate = convertedDate.setDate(convertedDate.getDate() + 30);
        defaultEndDate = new Date(format(defaultEndDate,'yyyy-MM-dd'));
        this.state = { 
            clientListCalled: 0, 

            selectedClientId: 0,   
            selectedClient: [],   
            clientsOptions: [],

            selectedEventId: 0, 
            selectedEvent: [], 
            eventsOptions: [], 

            selectedShiftId: 0, 
            selectedShift: [],
            shiftsOptions: [],  

            selectedLocId: 0, 
            selectedLocation: [],
            locationsOptions: [], 

            eventStatusIds: [],
            shiftStatusIds: [], 
            includeDate: true,
            defaultStartDate: '',
            defaultEndDate: '',
            selectedStartDate: startfrom,
            selectedEndDate: this.props.unallocatedShifts ? endTo : defaultEndDate,
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            dateValue:this.props.unallocatedShifts ? 1 : 0,
            unallocatedShift:true,
            departmentsList:[],
            deptMultiSelList:[],
            selectedDepartments:[]
        }
    }

    onShiftStatusDataChange = (selectedStatus) =>{
        let selStatus = []; 
        selectedStatus.forEach((item) => {
            selStatus.push(parseInt(item.value,10));
        });
        this.setState({shiftStatusIds:selStatus});
    }

    onEventStatusDataChange = (selectedStatus) =>{
        let selStatus = []; 
        selectedStatus.forEach((item) => {
            selStatus.push(parseInt(item.value,10));
        });
        this.setState({eventStatusIds:selStatus});
    }

    sendFilterData = () => {
        let filtersSelected = 0; 
        let arrClientIds = [];
        if(this.state.selectedClient && this.state.selectedClient.length) {
            this.state.selectedClient.forEach(item => {
                if(Number(item.id) > 0) {
                    arrClientIds.push(item.id);
                    filtersSelected = 1; 
                }
            }) 
        }

        let arrEventIds = [];
        if(this.state.selectedEvent && this.state.selectedEvent.length) {
            this.state.selectedEvent.forEach(item => {
                if(Number(item.id) > 0) {
                    arrEventIds.push(item.id);
                    filtersSelected = 1; 
                }
            }) 
        }
        let arrShiftIds = [];
        if(this.state.selectedShift && this.state.selectedShift.length) {
            this.state.selectedShift.forEach(item => {
                if(Number(item.id) > 0) {
                    arrShiftIds.push(item.id);
                    filtersSelected = 1; 
                }
            }) 
        }

        let arrLocIds = [];
        if(this.state.selectedLocation && this.state.selectedLocation.length) {
            this.state.selectedLocation.forEach(item => {
                if(Number(item.id) > 0) {
                    arrLocIds.push(item.id);
                    filtersSelected = 1; 
                }
            }) 
        }

        let arrEventStatIds = []; 
        this.state.eventStatusIds.forEach(item => { arrEventStatIds.push(Number(item)); }); 
        let arrShiftStatIds = []; 
        this.state.shiftStatusIds.forEach(item => { arrShiftStatIds.push(Number(item)); }); 
        
        if(arrEventStatIds.length || arrShiftStatIds.length) filtersSelected = 1; 
        if(this.state.selectedDepartments.length > 0) filtersSelected = 1; 

        let fromDate = 0; 
        let endDate = 0;
        let displayStartDate = '';
        let displayEndDate = '';
        if(this.state.includeDate) {
            // let timeZone =  getUserTimeZone(window.location);
            fromDate = format(new Date(this.state.selectedStartDate), 'yyyy-MM-dd');
            endDate = format(new Date(this.state.selectedEndDate), 'yyyy-MM-dd');
            displayStartDate = format(new Date(this.state.selectedStartDate), 'dd/MM/yyyy');
            displayEndDate = format(new Date(this.state.selectedEndDate), 'dd/MM/yyyy');
            filtersSelected = 1; 
        }
        if(this.state.unallocatedShift){
            filtersSelected = 1; 
        }
        let filterData = {departments:this.state.selectedDepartments,clientsIds:arrClientIds, eventIds:arrEventIds, shiftIds:arrShiftIds, locIds:arrLocIds, eventStatIds:arrEventStatIds, shiftStatusIds:arrShiftStatIds, selectedStartDate:fromDate, selectedEndDate:endDate,displayStartDate:displayStartDate,displayEndDate:displayEndDate, filtersSelected:filtersSelected, unallocatedShift:this.state.unallocatedShift}; 
        this.props.applyFilters(filterData); 
    }

    resetFilters = () => { 
        eventStatusData = []; // TO RESET MULTISEL VALUES 
        shiftStatusData = []; // TO RESET MULTISEL VALUES 
        this.setState({ 
            selectedClientId: 0,   
            selectedClient: [],   

            selectedEventId: 0, 
            selectedEvent: [], 

            selectedShiftId: 0, 
            selectedShift: [],

            selectedLocId: 0, 
            selectedLocation: [],

            eventStatusIds: [],
            shiftStatusIds: [], 

            includeDate: true, 
            selectedStartDate: this.state.defaultStartDate,
            selectedEndDate: this.state.defaultEndDate,
            resetFilterClicked: 0,
            applyFilterClicked: 1,
            dateValue:0,
            unallocatedShift:false,
            selectedDepartments: []
        }); 

        // TO RESET MULTISEL VALUES 
        EVENT_STATUS.forEach(item => {
            eventStatusData.push({value:item.statusCode,label:item.statusString}); 
        });
        
        // SHIFT_STATUS.forEach(item => {
        //     shiftStatusData.push({value:item.statusCode,label:item.statusString}); 
        // });  

        shiftStatusData = [...arrFirst, ...arrNext]; 

        this.props.filterClientsListAction(); 
        this.props.shiftsFilterEventsListAction(); 
        this.props.shiftsFilterShiftsListAction(); 
        this.props.shiftsFilterLocationsListAction();
        this.loadMultiSelDeptValues(); 
    }

    onDateCheck = (e) => {
        this.setState({includeDate:!this.state.includeDate, dateValue:1-this.state.dateValue}) 
    }
    handleClientChange = (selectedClient) => {
        let clId = 0; 
        let selClient = []; 
        if(selectedClient.length>0){
            selClient = selectedClient; 
            clId = selectedClient[0].id; 
            let dataObj = {clientsIds:[clId]}; 
            this.props.shiftsFilterEventsListAction(dataObj); 
            this.props.shiftsFilterShiftsListAction(dataObj); 
            this.props.shiftsFilterLocationsListAction(dataObj); 
        } 
        this.setState({selectedClient:selClient, selectedClientId:clId});  
    }
    
    handleRemoveClient = (e) => { 
        if(e==='') {
            this.props.shiftsFilterEventsListAction(); 
            this.props.shiftsFilterShiftsListAction(); 
            this.props.shiftsFilterLocationsListAction(); 
        } 
    }

    handleEventChange = (selectedEvent) => {
        let eventId = 0; 
        let selEvent = []; 
        if(selectedEvent.length>0){
            selEvent = selectedEvent; 
            eventId = selectedEvent[0].id; 

            let arrClientIds = []
            if(this.state.selectedClient.length) {
                this.state.selectedClient.forEach(item => {
                    arrClientIds.push(item.id)
                }) 
            }

            let dataObj = {}; 
            if(arrClientIds.length) {
                dataObj = {clientsIds:arrClientIds,eventIds:[eventId]}; 
            }
            else {
                dataObj = {eventIds:[eventId]}; 
            }
            this.props.shiftsFilterShiftsListAction(dataObj); 
            this.props.shiftsFilterLocationsListAction(dataObj);
        } 
        this.setState({selectedEvent:selEvent, selectedEventId:eventId});  
    }
    
    handleRemoveEvent = (e) => {
        if(e==='') {
            this.props.shiftsFilterShiftsListAction(); 
            this.props.shiftsFilterLocationsListAction(); 
        } 
    }

    handleShiftChange = (selectedShift) => {
        let shiftId = 0; 
        let selShift = []; 
        if(selectedShift.length>0){
            selShift = selectedShift; 
            shiftId = selectedShift[0].id; 

            let arrClientIds = []
            if(this.state.selectedClient.length) {
                this.state.selectedClient.forEach(item => {
                    arrClientIds.push(item.id)
                }) 
            }

            let arrEventIds = []
            if(this.state.selectedEvent.length) {
                this.state.selectedEvent.forEach(item => {
                    arrEventIds.push(item.id)
                }) 
            }

            let dataObj = {}; 
            if(arrClientIds.length && arrEventIds.length) {
                dataObj = {clientsIds:arrClientIds, eventIds:arrEventIds, shiftIds:[shiftId]}; 
            }
            else if(arrClientIds.length) {
                dataObj = {clientsIds:arrClientIds, shiftIds:[shiftId]}; 
            }
            else if(arrEventIds.length) {
                dataObj = {eventIds:arrEventIds, shiftIds:[shiftId]}; 
            }
            else {
                dataObj = {shiftIds:[shiftId]}; 
            }
            this.props.shiftsFilterLocationsListAction(dataObj);
            
        } 
        this.setState({selectedShift:selShift, selectedshiftId:shiftId});  
    }
    
    handleRemoveShift = (e) => {
        if(e==='') {
            this.props.shiftsFilterLocationsListAction(); 
        } 
    }

    handleLocationChange = (selectedLocation) => {
        let locId = 0; 
        let selLoc = []; 
        if(selectedLocation.length>0){
            selLoc = selectedLocation; 
            locId = selectedLocation[0].id; 
        } 
        this.setState({selectedLocation:selLoc, selectedLocId:locId});  
    }
    
    handleRemoveLocation = (e) => {
    }

    onHandleChange = (e) => {  
        if(e.target.name==='eventStatus') { 
            this.setState({eventStatusIds:e.target.value});  
        }
        else if(e.target.name==='shiftStatus') { 
            this.setState({shiftStatusIds:e.target.value});  
        }
    }

    onStartDateChange = (date) =>{
        let startDate = new Date()
        if(date){
            startDate = new Date(date);
        }
        if(this.state.selectedEndDate < startDate) {
            this.setState({selectedStartDate:startDate,selectedEndDate:startDate});    
        }
        else {
            this.setState({selectedStartDate:startDate});    
        }
        
    }

    onEndDateChange = (date) =>{ 
        let endDate = new Date()
        if(date){
            endDate = new Date(date);
        }
        this.setState({selectedEndDate:endDate});  
    }

    onUnallocatedShiftChecked = (e) =>{
        this.setState({unallocatedShift:!this.state.unallocatedShift});
    }

    loadMultiSelDeptValues() {
        let allDept = []; 
        let selectedDepartments = [];
        if(this.state.departmentsList.length > 0) {
           let tmpObj = {}; 
           let len = this.state.departmentsList.length; 
           let deptId = 0;  
           this.state.departmentsList.forEach((item,index) => { 
              tmpObj = {value:item.id, label:titleCase(item.name), inputVal:1}; 
              allDept.push(tmpObj);
              selectedDepartments.push(item.id) 
           }) 
        }
        this.setState({deptMultiSelList:allDept,selectedDepartments:selectedDepartments},()=>{
                // this.sendFilterData()
        });
     }

    handleChangeMultiSel = (selectedDepts) =>{
        let actUserDept = []; 
        selectedDepts.forEach((item) => {
           actUserDept.push(item.value);
        }); 
        this.setState({selectedDepartments:actUserDept}); 
    }

    componentDidMount() {
    }

    componentDidUpdate (prevProps) {

        if(this.props.filterClicked!==prevProps.filterClicked && this.state.clientListCalled===0) {
            this.setState({clientListCalled:1}); // TO PREVENT REPEATED API CALLS 
            this.props.filterClientsListAction(); 
            this.props.shiftsFilterEventsListAction(); 
            this.props.shiftsFilterShiftsListAction(); 
            this.props.shiftsFilterLocationsListAction();
            this.props.serverTimeAction();
        }

        if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
                
                //let defaultStartDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
                let defaultStartDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                let defaultEndDate = new Date(this.props.serverTimeList.current_date+"T00:00:00"); 
                let unAlloStartDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                let dashStartDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                defaultEndDate = new Date(unAlloStartDate.setDate(unAlloStartDate.getDate() + 30));
                let endTo = new Date(dashStartDate.setDate(dashStartDate.getDate() + 1)); 

                let selectedStartDate = this.state.selectedStartDate;
                let selectedEndDate = this.state.selectedEndDate;
                let displayStartDate = '';
                let displayEndDate = '';
                let unallocatedShift = this.state.unallocatedShift;
                if(this.props.applyFilterClicked === 0){
                    selectedStartDate = defaultStartDate;
                    selectedEndDate = this.props.unallocatedShifts?endTo:defaultEndDate;
                    unallocatedShift = this.props.unallocatedShift;
                }
                displayStartDate = format(selectedStartDate,'dd/MM/yyyy');
                displayEndDate = format(selectedEndDate,'dd/MM/yyyy');
                if(unallocatedShift){
                    this.props.shiftTitle(LBL_UNALLOCATED_SHIFT + " ("+displayStartDate+" - "+displayEndDate+")");
                }else{
                    this.props.shiftTitle(LBL_SHIFTS + " ("+displayStartDate+" - "+displayEndDate+")");
                }
                this.setState({defaultStartDate:defaultStartDate,defaultEndDate:defaultEndDate,
                                        selectedStartDate:selectedStartDate,selectedEndDate:selectedEndDate,
                                        unallocatedShift:unallocatedShift},()=>{
                    this.sendFilterData(); 
                })  
            }
        }  

        if(this.props.applyFilterClicked > 0 && this.props.applyFilterClicked!==prevProps.applyFilterClicked && this.state.applyFilterClicked < this.props.applyFilterClicked) {
            this.setState({applyFilterClicked:this.props.applyFilterClicked}); // TO PREVENT REPEATED API CALLS 
        }

        if(this.props.resetFilterClicked > 0 && this.props.resetFilterClicked!==prevProps.resetFilterClicked && this.state.resetFilterClicked < this.props.resetFilterClicked) {
            this.setState({resetFilterClicked:this.props.resetFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.resetFilters(); 
        }

        const {depActivity,filterClientsList,filterStatus,filterActivity,filterErrorData,shiftsFilterEventsList,shiftsFilterShiftsList,shiftsFilterLocationsList} = this.props; 

        if (depActivity && depActivity !== prevProps.depActivity) {
            let arrTmp = [];
            arrTmp = (depActivity && depActivity.length) ? depActivity.split('~~') : [];
            let actString = arrTmp[0]; 
            if(actString===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS) { 
                if(this.props.departmentsList.length===0) {
                      this.setState({departmentsList: []}, () => {
                         this.loadMultiSelDeptValues(); 
                      } ); 
                    }
                else{
                        this.setState({departmentsList: this.props.departmentsList}, () => {
                        this.loadMultiSelDeptValues(); 
                        });                  
                    }

            }
        }

        if (filterActivity && filterActivity !== prevProps.filterActivity) {
            let arrTmp = [];
            arrTmp = (filterActivity) ? filterActivity.split('~~') : [];
            let actString = arrTmp[0]; 

            if(actString===types.FILTER_CLIENTS_LIST_SUCCESS) { 
                let clientsOptions = [];  
                if(filterStatus===200) {
                    if(filterClientsList && Array.isArray(filterClientsList)){
                        filterClientsList.forEach(item => {             
                            clientsOptions.push({id:item.client_id, name:item.client_name});
                        });            
                    }
                }
                else {
                    console.log('Clients List Error '+JSON.stringify(filterErrorData)); 
                }
                this.setState({clientsOptions}); 
            }

            if(actString===types.SHIFTS_FILTER_EVENTS_LIST_SUCCESS) { 
                let eventsOptions = [];  
                if(filterStatus===200) {
                    if(shiftsFilterEventsList && Array.isArray(shiftsFilterEventsList)){
                        shiftsFilterEventsList.forEach(item => {             
                            eventsOptions.push({id:item.event_id, name:item.event_title});
                        });            
                    }
                }
                else {
                    console.log('Events List Error '+JSON.stringify(filterErrorData)); 
                }
                this.setState({eventsOptions}); 
            }

            if(actString===types.SHIFTS_FILTER_SHIFTS_LIST_SUCCESS) { 
                let shiftsOptions = [];  
                if(filterStatus===200) {
                    if(shiftsFilterShiftsList && Array.isArray(shiftsFilterShiftsList)){
                        shiftsFilterShiftsList.forEach(item => {             
                            shiftsOptions.push({id:item.shift_id, name:item.shift_title});
                        });            
                    }
                }
                else {
                    console.log('Shifts List Error '+JSON.stringify(filterErrorData)); 
                }
                this.setState({shiftsOptions}); 
            } 


            if(actString===types.SHIFTS_FILTER_LOCATIONS_LIST_SUCCESS) { 
                let locationsOptions = [];  
                if(filterStatus===200) {
                    if(shiftsFilterLocationsList && Array.isArray(shiftsFilterLocationsList)){
                        shiftsFilterLocationsList.forEach(item => {             
                            locationsOptions.push({id:item.location_id, name:item.location_name});
                        });            
                    }
                }
                else {
                    console.log('Shifts List Error '+JSON.stringify(filterErrorData)); 
                }
                this.setState({locationsOptions}); 
            } 

        }
    }
    
    render(){
        let {selectedClient,clientsOptions,  selectedEvent,eventsOptions, selectedShift,shiftsOptions, selectedLocation,locationsOptions, selectedStartDate, selectedEndDate, includeDate,dateValue,unallocatedShift} = this.state; 
        let paddingTopPix = shiftStatusData.length*40; // TO GIVE SCROLL SPACE FOR THE SHIFT STATUS DROPDOWN 

        return(
            <React.Fragment>
                <Form autoComplete="off" >
                    <div className="filter-category">
                        <div className="form-group">                   
                            <div className="row"> 
                                <div className="col-6"> <h4>
                                <div className="custom-checkbox" > 
                                        <input type="checkbox" id="unallocatedShift" name="unallocatedShift"  checked={unallocatedShift}   onChange={e => this.onUnallocatedShiftChecked(e)} />
                                        <label className="checkbox" htmlFor="unallocatedShift" ></label>
                                        <label htmlFor="unallocatedShift" > &nbsp; Show unallocated shifts</label> 
                                    </div></h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="filter-category">                   
                        <div className="row"> 
                            {/*<div className="col-6"> <h4>
                            <div className="custom-checkbox" > 
                                    <input type="checkbox" id="includeDate" name="includeDate"  checked={includeDate} value={dateValue}  onChange={e => this.onDateCheck(e)} />
                                    <label className="checkbox" htmlFor="includeDate" ></label>
                                    <label htmlFor="includeDate" > &nbsp; Date From</label> 
                                </div></h4>
                            </div>*/}
                            <div className="col-6"> <h4>{LBL_DATE_FROM}</h4></div>
                            <div className="col-6"> <h4>{LBL_DATE_TO}</h4></div>
                        </div>
                        <div className="form-group">
                            <div className="form-group"> 
                                <div className="row">
                                    <div className="col-6">
                                        <div className="calendar-input">  
                                            <DatePicker 
                                                selected={selectedStartDate}
                                                onChange={selected => this.onStartDateChange(selected)}
                                                name="startDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Select"
                                                //maxDate={new Date()}
                                                // minDate={new Date()}
                                                fixedHeight   
                                                disabled={!includeDate}       
                                            />
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="calendar-input ">  
                                            <DatePicker 
                                                selected={selectedEndDate}
                                                onChange={selected => this.onEndDateChange(selected)}
                                                name="endDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Select"
                                                //maxDate={new Date()}
                                                minDate={new Date(selectedStartDate)}
                                                fixedHeight     
                                                disabled={!includeDate}         
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="filter-category">
                        <div className="form-group">                   
                            <div className="row"> 
                                <div className="col-6">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="filter-category">
                        <div className="form-group">                   
                            <div className="row"> 
                                <div className="col-6">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="filter-category">
                        <div className="form-group">
                            <h4>{LBL_DEPARTMENTS}</h4>
                            <div className="form-group multisel_textbox">
                                    <div className="form-group select-input skills" >
                                    <CustomMultiSelect id={'dept'} data={this.state.deptMultiSelList} trimString='yes'  onChange={selected =>this.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' inputProps={{ tabIndex:"10" }} tabIndex="10"/>
                                    </div>
                            </div> 
                        </div>
                    </div>
                    <div className="filter-category">
                        <h4>{LBL_CLIENT}</h4>
                        <div className="form-group">
                            <div className="form-group select-input">
                                <Typeahead
                                    selected ={selectedClient}
                                    id="clients"
                                    labelKey="name"
                                    options={clientsOptions}
                                    placeholder="Choose Client..."
                                    inputProps={{ name:'clientId', className:''}}
                                    onChange={(s) => this.handleClientChange(s)}
                                    onInputChange={this.handleRemoveClient}
                                />  
                            </div>
                        </div>
                    </div>

                    <div className="filter-category">
                        <h4>{LBL_EVENT+' '+LBL_TITLE}</h4> 
                        <div className="form-group">
                            <div className="form-group select-input">
                                <Typeahead
                                    selected ={selectedEvent} 
                                    id="events"
                                    labelKey="name"
                                    options={eventsOptions}
                                    placeholder={"Choose "+LBL_EVENT+"..."}
                                    inputProps={{ name:'eventId', className:''}}
                                    onChange={(s) => this.handleEventChange(s)}
                                    onInputChange={this.handleRemoveEvent}
                                />  
                            </div>
                        </div>
                    </div>
                    <div className="filter-category">
                        <h4>{LBL_SHIFT}</h4>
                        <div className="form-group">
                            <div className="form-group select-input">
                                <Typeahead
                                    selected ={selectedShift} 
                                    id="shifts"
                                    labelKey="name"
                                    options={shiftsOptions}
                                    placeholder="Choose Shift..."
                                    inputProps={{ name:'shiftId', className:''}}
                                    onChange={(s) => this.handleShiftChange(s)}
                                    onInputChange={this.handleRemoveShift}
                                />  
                            </div>
                        </div>
                    </div>
        
                    <div className="filter-category">
                        <h4>{LBL_LOCATION}</h4>
                        <div className="form-group">
                            <div className="form-group select-input">
                                <Typeahead
                                    selected ={selectedLocation} 
                                    id="locations"
                                    labelKey="name"
                                    options={locationsOptions}
                                    placeholder="Choose Location..."
                                    inputProps={{ name:'locationId', className:''}}
                                    onChange={(s) => this.handleLocationChange(s)}
                                    onInputChange={this.handleRemoveLocation}
                                />  
                            </div>
                        </div>
                    </div>
                    
                    {/* COMMENTED IN 29TH March 2021 ON CLIENT REQUEST  */}
                    {/* <div className="filter-category">
                        <div className="form-group">
                            <h4>{LBL_EVENT} status</h4>
                            <div className="form-group multisel_textbox">
                                <div className="form-group select-input skills" >
                                    <CustomMultiSelect data={eventStatusData}  onChange={selected =>this.onEventStatusDataChange(selected)} isTextBox={false} needSelectAll={true} />
                                </div>
                            </div>
                        </div>    
                    </div>   */}

                    <div className="filter-category"> 
                        <div className="form-group">
                            <h4>{LBL_SHIFT} status</h4>
                            <div className="form-group multisel_textbox">
                                <div className="form-group select-input skills" >
                                    <CustomMultiSelect data={shiftStatusData}  onChange={selected =>this.onShiftStatusDataChange(selected)} isTextBox={false} needSelectAll={true} needSelectAll={true} />
                                </div>
                            </div>
                        </div>   
                    </div>  



                    {/* TO ENABLE THE SCROLL SPACE FOR SHIFT STATUS DROPDOWN  */}
                    <div style={{paddingTop:paddingTopPix}}></div>

                    {/* <div className="filter-category">
                        <h4>PO Number</h4>
                        <div className="form-group">
                            <div className="form-group text-input">
                                <input type="text" />
                            </div>
                        </div>
                    </div> */}
                </Form>    
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => { 
    return {
        filterClientsList: state.event.filterClientsList, 
        filterStatus: state.event.filterStatus,
        filterActivity: state.event.filterActivity,
        filterErrorData: state.event.filterErrorData,
        shiftsFilterEventsList: state.event.shiftsFilterEventsList,
        shiftsFilterShiftsList: state.event.shiftsFilterShiftsList,
        shiftsFilterLocationsList: state.event.shiftsFilterLocationsList,
        unallocatedShifts:state.commons.fromDashboard,
        depActivity: state.afltDepartments.activity,
        departmentsList: state.afltDepartments.departmentsList,
        serverTimeList: state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        filterClientsListAction:filterClientsListAction,  
        shiftsFilterEventsListAction:shiftsFilterEventsListAction,   
        shiftsFilterShiftsListAction:shiftsFilterShiftsListAction,
        shiftsFilterLocationsListAction:shiftsFilterLocationsListAction,
        fromDashboard:fromDashboard,     
        serverTimeAction:serverTimeAction,     
        shiftTitle:shiftTitle     
    },dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(FilterShift);

